import api from "./api-service";

const baseUrl = "settings";

export const getAllSettings = () => {
  return api().get(baseUrl);
};

export const saveConsentFormUrl = (newUrl) => {
  return api().post(baseUrl + "/consent-term", {
    consentTermUrl: newUrl,
  });
};

export const getCacheState = () => {
  return api().get("sync/hash");
};

export const resetCache = () => {
  return api().post("sync/cache/reset");
};